module.exports = __webpack_public_path__ + "img/pile1.b65bdbf7.png";